import dayjs from 'dayjs';
import { convertLimitTemperature } from '../../devices/util/convert-temp-units';
import { convertToTempUnits } from '../../devices/util';
import { SetpointLimits } from '../../../../types/generated-types';
import { TStatConfig } from '../types';
import { TemperatureUnit } from '../../../system/models/temperatureUnits';

/**
 * Estimate for how long it will take to commit bulk config changes
 */
export function getTStatConfigurationEstimate(numTStats: number) {
  // Assuming approximately 5 seconds per TStat config. In reality, it's probably less,
  // but it's better to display a conservative estimate to the user
  const seconds = (numTStats || 0) * 5;
  return dayjs(seconds * 1000).format('m[m]:s[s]'); // e.g '2m:30s'
}

/**
 * Convert the given setpoints to the desired target units
 */
export function convertSetpoints(
  setpoints: TStatConfig['setpoints'],
  targetUnits: TemperatureUnit,
): TStatConfig['setpoints'] {
  const { heat, cool, units } = setpoints;
  return {
    ...setpoints,
    units: targetUnits,
    heat: convertToTempUnits(heat, targetUnits, units, 0) || heat,
    cool: convertToTempUnits(cool, targetUnits, units, 0) || cool,
    target:
      setpoints.target == null
        ? undefined
        : (convertToTempUnits(setpoints.target, targetUnits, units, 2) ??
          setpoints.target),
  };
}

/**
 * Convert the given setpoint limits to the desired target units
 */
export function convertSetpointLimits(
  setpointLimits: SetpointLimits,
  targetUnits: TemperatureUnit,
  currentUnits: TemperatureUnit,
): SetpointLimits {
  const { heat, cool } = setpointLimits;
  return {
    heat: {
      min:
        convertLimitTemperature(heat.min, targetUnits, currentUnits) ??
        heat.min,
      max:
        convertLimitTemperature(heat.max, targetUnits, currentUnits) ??
        heat.max,
    },
    cool: {
      min:
        convertLimitTemperature(cool.min, targetUnits, currentUnits) ??
        cool.min,
      max:
        convertLimitTemperature(cool.max, targetUnits, currentUnits) ??
        cool.max,
    },
  };
}
